import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetRecordMetadataPropertySchemaSetsDocument,
  type GetRecordMetadataPropertySchemaSetsQuery,
  type GetRecordMetadataPropertySchemaSetsQueryVariables,
} from "~/features/admin/recordMetadataSchema/gqls";

/**
 * Loads the full record-metadata property-schema-set list. Tenant scoping is
 * enforced server-side via the Hasura session (no `tenantId` variable — V1
 * parity), so the whole list is fetched at once and filtered / paginated
 * client-side.
 */
export function useRecordMetadataSchemaList() {
  return useSuspenseQuery<GetRecordMetadataPropertySchemaSetsQuery, GetRecordMetadataPropertySchemaSetsQueryVariables>(
    GetRecordMetadataPropertySchemaSetsDocument,
    { fetchPolicy: "cache-and-network" },
  );
}
